export const PROPERTY_DEFAULT_PAGE = 1;
export const PROPERTY_DEFAULT_PAGE_SIZE = 12;

export const PROPERTY_ENDPOINTS = {
  // 1. List Properties (General / Latest)
  listGeneral: "/all/property/latestList",
  listAdmin: "/property/list",

  // 2. List Properties with Filters / Preferred (Partner View)
  listPreferred: "/property/list/preferred",

  // 3. List My Properties
  listMy: "/property/myProperty",
  listMyPreferred: "/property/list/my/preferred",

  // 4. Get Property Details by ID
  details: (id) => `/property/id/${id}`,

  // 5. Add Property
  create: "/property/addProperty",

  // 6. Delete Property
  remove: (id) => `/property/deleteProperty/${id}`,

  // 7. Comments & Inquiries on a Property
  comments: (userId, propertyId) =>
    `/property/requestPropertyComments/${userId}/${propertyId}`,

  // 8. Add Comment / Reply
  addComment: "/property/addRequestPropertyComment",

  // 9. Edit Comment
  editComment: "/property/editRequestPropertyComment",

  // 10. Delete Comment
  deleteComment: (commentId) =>
    `/property/deleteRequestPropertyComment/${commentId}`,

  // Helper metadata endpoints
  states: (countryId = 1) => `/admin/states/${countryId}`,
  cities: (stateId) => `/admin/cities/${stateId}`,
  propertyTypes: "/all/property/types",
};

export const PROPERTY_TABS = {
  ALL: "all",
  PREFERRED: "preferred",
  MY: "my",
};
